export default "/images/0400264365d020871236ad2939c06907.avif";